import {Controller} from "@hotwired/stimulus"

const TIMESHEETS_BOX_SELECTOR = "#employee-show-timesheets-box"
const OVERRIDE_FIELD_SELECTOR = ".broken-week-override-field"
const OVERRIDE_INPUT_SELECTOR = ".broken-week-hours-input"
const CONFIRM_BUTTON_SELECTOR = ".broken-week-override-confirm"
const CSRF_META_SELECTOR = 'meta[name="csrf-token"]'

export default class extends Controller {
  static targets = ["hours", "link", "modal", "weekNumber", "yearNumber"]
  static values = {saveUrl: String}

  open(event) {
    event.preventDefault()

    const resetButton = event.currentTarget

    this.weekNumberTarget.textContent = resetButton.dataset.week
    this.yearNumberTarget.textContent = resetButton.dataset.year
    this.hoursTarget.textContent = resetButton.dataset.overrideHours
    this.linkTarget.setAttribute("href", resetButton.dataset.overrideUrl)

    window.jQuery(this.modalTarget).modal("show")
  }

  close() {
    window.jQuery(this.modalTarget).modal("hide")
  }

  markDirty(event) {
    const input = event.currentTarget
    this.toggleConfirmButton(input, this.hasPendingChange(input))
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.saveInput(event.currentTarget)
    }
  }

  confirm(event) {
    event.preventDefault()
    const input = event.currentTarget.closest(OVERRIDE_FIELD_SELECTOR).querySelector(OVERRIDE_INPUT_SELECTOR)
    this.saveInput(input)
  }

  saveInput(input) {
    const container = input.closest(OVERRIDE_FIELD_SELECTOR)
    const employeeId = container.dataset.employeeId
    const year = container.dataset.year
    const week = container.dataset.week
    const newValue = parseFloat(input.value)
    const originalValue = parseFloat(input.dataset.originalValue)

    if (Number.isNaN(newValue) || newValue < 0) {
      this.restoreOriginalValue(input)
      return
    }

    if (newValue === originalValue) {
      this.toggleConfirmButton(input, false)
      return
    }

    const csrfToken = document.querySelector(CSRF_META_SELECTOR).getAttribute("content")

    fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        employee_broken_week_hour_override: {
          year_number: year,
          week_number: week,
          override_hours: newValue,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.errors ? data.errors.join(", ") : input.dataset.unknownErrorText)
          })
        }
        this.refreshTimesheets(employeeId)
      })
      .catch((error) => {
        this.restoreOriginalValue(input)
        alert(`${input.dataset.saveErrorText}: ${error.message}`)
      })
  }

  hasPendingChange(input) {
    const newValue = parseFloat(input.value)
    const originalValue = parseFloat(input.dataset.originalValue)
    return Number.isNaN(newValue) || newValue !== originalValue
  }

  restoreOriginalValue(input) {
    input.value = input.dataset.originalValue
    this.toggleConfirmButton(input, false)
  }

  toggleConfirmButton(input, visible) {
    const button = input.closest(OVERRIDE_FIELD_SELECTOR).querySelector(CONFIRM_BUTTON_SELECTOR)
    if (button) button.hidden = !visible
  }

  // Bridges to the legacy jQuery timesheet refresh (app/assets/javascripts/functions.js).
  refreshTimesheets(employeeId) {
    window.remoteGetEmployeeShowData(null, TIMESHEETS_BOX_SELECTOR, employeeId)
  }
}
